var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAsambaSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.636,
    height: 60.372,
    viewBox: "0 0 49.636 60.372",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(154.115 339.867)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-104.175-221.111c-4.525-10.485-10.032-16.052-16.368-16.55l-.38-.03h-1.1l-.38.03c-6.336.5-11.843,6.065-16.368,16.55a82.4,82.4,0,0,0-3.231,8.977l-.571,1.906h10.18l10.922-26.141,10.922,26.141h10.18l-.571-1.906a82.535,82.535,0,0,0-3.231-8.977",
    transform: "translate(-7.823 -69.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-138.775-328.983c4.525,10.485,10.032,16.052,16.368,16.55l.38.03h1.105l.379-.03c6.336-.5,11.843-6.066,16.368-16.55a82.4,82.4,0,0,0,3.231-8.977l.571-1.906h-10.18l-10.922,26.142L-132.4-339.867h-10.18l.571,1.906a82.531,82.531,0,0,0,3.231,8.977",
    transform: "translate(-7.823)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.636,
    height: 2.587,
    transform: "translate(-154.115 -310.973)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsambaSymbol);
export default __webpack_public_path__ + "static/media/asamba-symbol.23dc93422b21f8562c5e17590d3b6fe5.svg";
export { ForwardRef as ReactComponent };